import { createContext } from "react";

export const DentistMedicalRecordContext = createContext({})
